<script lang="ts">
  let { compact = false }: { compact?: boolean } = $props();
</script>
<a class="bibow-brand text-decoration-none" href="/" data-spa aria-label="Bibow Playground Rentals home">
  <img
    class="brand-mark"
    src="/favicon.png"
    alt=""
    width="42"
    height="42"
    aria-hidden="true"
    decoding="async"
  />
  <span class="brand-copy">
    <strong>Bibow</strong>
    {#if !compact}<small>Playground Rentals</small>{/if}
  </span>
</a>
